import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  getAdminFees,
  getAdminPaidFees,
  getAdminStudentLastPaidFee,
  collectAdminFee,
  updateAdminFee,
  deleteAdminFee,
  generateAdminReceipt,
} from "../../api/admin/fees.api";

/* =========================================================
   FETCH ALL FEES
========================================================= */

export const fetchFees = createAsyncThunk(
  "admin/fees/fetch",

  async (
    {
      page = 1,
      limit = 10,
      search = "",
    } = {},
    { rejectWithValue }
  ) => {
    try {

      const res = await getAdminFees({
        page,
        limit,
        search,
      });

      if (!res.success) {
        return rejectWithValue(
          res.message || "Failed to fetch fees"
        );
      }

      return res;

    } catch (error) {

      return rejectWithValue(
        error.message || "Unexpected error occurred"
      );
    }
  }
);

/* =========================================================
   FETCH PAID FEES
========================================================= */

export const fetchPaidFees = createAsyncThunk(
  "admin/fees/fetchPaid",

  async (
    {
      page = 1,
      limit = 10,
      search = "",
      student_id = "",
      month = "",
      year = "",
      status = "all",
    } = {},
    { rejectWithValue }
  ) => {
    try {
      const res = await getAdminPaidFees({
        page,
        limit,
        search,
        student_id,
        month,
        year,
        status,
      });

      if (!res.success) {
        return rejectWithValue(
          res.message || "Failed to fetch paid fees"
        );
      }

      return res;

    } catch (error) {
      return rejectWithValue(
        error.message || "Unexpected error occurred"
      );
    }
  }
);

/* =========================================================
   FETCH STUDENT LAST PAID FEE
========================================================= */

export const fetchStudentLastPaidFee = createAsyncThunk(
  "admin/fees/fetchLastPaid",

  async (studentId, { rejectWithValue }) => {
    try {
      const res = await getAdminStudentLastPaidFee(studentId);

      if (!res.success) {
        return rejectWithValue(
          res.message || "Failed to fetch last paid fee info"
        );
      }

      return res.data;

    } catch (error) {
      return rejectWithValue(
        error.message || "Unexpected error occurred"
      );
    }
  }
);

/* =========================================================
   COLLECT FEE
========================================================= */

export const collectFee = createAsyncThunk(
  "admin/fees/collect",

  async (payload, { rejectWithValue }) => {
    try {

      const res = await collectAdminFee(payload);

      if (!res.success) {
        return rejectWithValue(
          res.message || "Failed to collect fee"
        );
      }

      return res;

    } catch (error) {

      return rejectWithValue(
        error.message || "Unexpected error occurred"
      );
    }
  }
);

/* =========================================================
   UPDATE FEE
========================================================= */

export const updateFee = createAsyncThunk(
  "admin/fees/update",

  async (
    { id, feeData },
    { rejectWithValue }
  ) => {
    try {

      const res = await updateAdminFee(
        id,
        feeData
      );

      if (!res.success) {
        return rejectWithValue(
          res.message || "Failed to update fee"
        );
      }

      return res;

    } catch (error) {

      return rejectWithValue(
        error.message || "Unexpected error occurred"
      );
    }
  }
);

/* =========================================================
   DELETE FEE
========================================================= */

export const deleteFee = createAsyncThunk(
  "admin/fees/delete",

  async (id, { rejectWithValue }) => {
    try {

      const res = await deleteAdminFee(id);

      if (!res.success) {
        return rejectWithValue(
          res.message || "Failed to delete fee"
        );
      }

      return {
        id,
        message: res.message,
      };

    } catch (error) {

      return rejectWithValue(
        error.message || "Unexpected error occurred"
      );
    }
  }
);

/* =========================================================
   GENERATE RECEIPT
========================================================= */

export const generateReceipt = createAsyncThunk(
  "admin/fees/generateReceipt",

  async (id, { rejectWithValue }) => {
    try {

      const res = await generateAdminReceipt(id);

      if (!res.success) {
        return rejectWithValue(
          res.message || "Failed to generate receipt"
        );
      }

      return res;

    } catch (error) {

      return rejectWithValue(
        error.message || "Unexpected error occurred"
      );
    }
  }
);